"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.UiDiagnosisSelect = void 0;
const menu_1 = require("client/components/menu");
const store_1 = require("client/modules/inventory/modules/inventory-detail/store");
const mobx_1 = require("mobx");
const mobx_react_1 = require("mobx-react");
const react_1 = require("react");
const React = require("react");
require("./diagnosis-select.less");
const option_1 = require("./option");
let UiDiagnosisSelect = class UiDiagnosisSelect extends react_1.Component {
    constructor() {
        super(...arguments);
        this.showMenu = false;
        this.searchValue = "";
        this.handleFocus = () => {
            this.focused = true;
            this.textField.focus();
        };
        this.handleOnMenuAction = (item) => {
            store_1.inventoryDetailStore.addIcd10ToList(item);
            // console.log('mouse Down');
            // if (item) {
            //   this.searchValue = item.label;
            //   if (this.props.values.filter(i => i.id === item.id).length === 0) {
            //   this.props.values.push(item);
            //   }
            //   console.log(this.props);
            //   console.log(this.props.values);
            //   this.textField.value = '';
            //   this.textField.focus();
            //   this.showMenu = false;
            // }
            // return;
            // this.focused = false;
        };
        this.handleOnChange = (event) => {
            const { value } = event.target;
            this.searchValue = value;
            this.props.onSearch && this.props.onSearch(this.searchValue);
        };
        this.handleOnOptionClick = (item) => {
            if (typeof item.id === "string") {
                const itemId = parseInt(item.id, 10);
                store_1.inventoryDetailStore.removeIcd10FromList(itemId);
            }
            if (typeof item.id === "number") {
                store_1.inventoryDetailStore.removeIcd10FromList(item.id);
            }
            this.focused = false;
            // this.props.values.splice(
            //   this.props.values.findIndex(i => i.id === item.id),
            //   1,
            // );
            // this.focused = false;
            // this.props.onChange && this.props.onChange(this.props.values);
        };
    }
    get filteredOptions() {
        return this.props.options
            ? this.props.options.filter(o => o.label.toLowerCase().indexOf(this.searchValue.toLowerCase()) !== -1)
            : [];
    }
    render() {
        const { label, required = false, values = [], missing } = this.props;
        const floatLabel = this.focused || this.props.values.length;
        const floatLabelClass = floatLabel ? "has-value" : "";
        const className = this.props.className || "";
        const isMissing = missing ? "diagnosis-select--missing" : "";
        return (React.createElement("div", { className: `diagnosis-select ${className} ${floatLabelClass} ${isMissing}`, onBlur: () => {
                this.showMenu = false;
            }, onClick: () => {
                this.focused = true;
            }, onFocus: () => {
                this.showMenu = true;
            } },
            React.createElement(menu_1.Menu, { className: "diagnosis-select__select", data: this.props.onSearch ? this.props.options : this.filteredOptions, showMenu: this.showMenu, onAction: this.handleOnMenuAction },
                React.createElement("a", { className: "diagnosis-select__input" },
                    React.createElement("label", { className: `diagnosis-select__label ${floatLabelClass}` }, label),
                    React.createElement("div", { className: "diagnosis-select__input-block" },
                        React.createElement("div", { className: "diagnosis-select__options" },
                            typeof values !== "string"
                                ? values &&
                                    values.map((v, i) => (React.createElement(option_1.Option, { key: i, item: v, onCloseClick: this.handleOnOptionClick })))
                                : null,
                            React.createElement("input", { autoFocus: this.focused, className: `diagnosis-select__text-input ${floatLabelClass}`, onChange: this.handleOnChange, ref: (input) => {
                                    this.textField = input;
                                }, required: required, onFocus: () => {
                                    this.handleFocus();
                                    this.searchValue = "";
                                    this.showMenu = true;
                                    this.props.onSearch &&
                                        this.props.onSearch(this.searchValue);
                                } })))))));
    }
};
__decorate([
    mobx_1.computed
], UiDiagnosisSelect.prototype, "filteredOptions", null);
__decorate([
    mobx_1.observable
], UiDiagnosisSelect.prototype, "focused", void 0);
__decorate([
    mobx_1.observable
], UiDiagnosisSelect.prototype, "showMenu", void 0);
__decorate([
    mobx_1.observable
], UiDiagnosisSelect.prototype, "searchValue", void 0);
UiDiagnosisSelect = __decorate([
    mobx_react_1.observer
], UiDiagnosisSelect);
exports.UiDiagnosisSelect = UiDiagnosisSelect;



//////////////////
// WEBPACK FOOTER
// ./src/client/modules/inventory/modules/inventory-detail/components/edit-inventory/diagnosis-select/diagnosis-select.tsx
// module id = 3479
// module chunks = 0